import React from 'react';
import { useSelector } from 'react-redux';
import { bool } from 'prop-types';
import get from 'lodash/get';
import Accordion from 'yoda-core-components/lib/components/Accordion/accordion';
import BVSummary from 'yoda-site-components/lib/components/BVSummary/BVSummary';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { selectFeatureFlags } from 'yoda-site-components/lib/selectors/ContextSelector';
import { selectProductDetailsBySource } from 'yoda-site-components/lib/selectors/PdpNameSpaceSelector';
import { selectProductReviewID } from 'yoda-site-components/lib/selectors/ProductDetailsSelector';
import BazaarVoice from './BazaarVoiceLazy';

export const renderMobileAccordion = (featureFlags, productDetails, productReviewID) => {
    const ArrayOfAccordionSection = [];
    if (get(featureFlags, 'bazaarVoice', true)) {
        const ReviewAccordionTitle = (
            <>
                <div
                    id="reviewSectionId"
                    className={dt(['inline-block', 'sm:!text-lg', 'sm:!leading-6', 'text-black'])}
                >
                    Reviews
                </div>

                <div className={dt(['inline-block', 'align-middle'])}>
                    <ErrorBoundary>
                        <BVSummary isAccordion="true" productDetails={productDetails} />
                    </ErrorBoundary>
                </div>
            </>
        );

        let content = (
            <ErrorBoundary>
                <BazaarVoice
                    containerId="BVReviewsContainer"
                    contentType="reviews"
                    submissionContainerId="BVSubmissionContainer"
                />
            </ErrorBoundary>
        );

        if (get(featureFlags, 'customerPhotos', true)) {
            content = [
                <ErrorBoundary>
                    <>
                        <>
                            <div
                                data-bv-show="review_highlights"
                                data-bv-product-id={productReviewID}
                                id="reviewSectionId"
                            />
                            <div
                                data-bv-show="reviews"
                                data-bv-product-id={productReviewID}
                                id="reviewSectionId"
                            />{' '}
                        </>

                        <BazaarVoice
                            containerId="BVReviewsContainer"
                            submissionContainerId="BVReviewsContainer"
                            contentType="reviews"
                            // showLoader={false}
                        />
                    </>
                </ErrorBoundary>,
                <ErrorBoundary>
                    <BazaarVoice containerId="bv-gallery" showLoader={false} />
                </ErrorBoundary>,
            ];
        }

        ArrayOfAccordionSection.push({
            header: ReviewAccordionTitle,
            panel: content,
            key: 'reviewSectionId',
        });
    }

    if (get(featureFlags, 'bazaarVoice', true)) {
        ArrayOfAccordionSection.push({
            header: (
                <span
                    id="QASectionId"
                    className={dt(['inline-block', 'sm:!text-lg', 'sm:!leading-6', 'text-black'])}
                >
                    Questions & Answers
                </span>
            ),
            panel: (
                <ErrorBoundary>
                    <div data-bv-show="questions" data-bv-product-id={productReviewID} />

                    <BazaarVoice
                        containerId="BVQuestionsContainer"
                        contentType="qa"
                        submissionContainerId="BVQASubmissionContainer"
                    />
                </ErrorBoundary>
            ),
            key: 'QASectionId',
        });
    }
    return ArrayOfAccordionSection;
};

const RenderBazaarVoice = (props) => {
    const featureFlags = useSelector((state) => selectFeatureFlags(state));
    const productDetails = useSelector((state) => selectProductDetailsBySource(false)(state));
    const productReviewID = useSelector((state) => selectProductReviewID(state));
    if (props.mobileTabletLogic) {
        return renderMobileAccordion(featureFlags, productDetails, productReviewID);
    }
    if (get(featureFlags, 'enableDesktopAccordionBV', true)) {
        return (
            <ErrorBoundary>
                <Accordion automationId="product-info-accordion" className={dt(['lg:mb-10'])}>
                    {renderMobileAccordion(featureFlags, productDetails, productReviewID)}
                </Accordion>
            </ErrorBoundary>
        );
    }
    return null;
};

RenderBazaarVoice.defaultProps = {
    mobileTabletLogic: false,
};

RenderBazaarVoice.propTypes = {
    mobileTabletLogic: bool,
};

export default RenderBazaarVoice;
